/* Squelette du parcours passager pendant /scan/init. Il reprend la géométrie
   réelle de la page (hauteur du carrousel, cartes de lots, formulaire) pour que
   l'arrivée des données ne décale rien à l'écran. */

/** Bloc shimmer — `.shimmer` porte le reflet, défini dans index.css. */
function Bar({ className = "" }) {
  return <div className={`shimmer rounded-md ${className}`} />;
}

export default function ScanSkeleton() {
  return (
    <div className="space-y-6" data-testid="scan-skeleton" aria-hidden="true">
      {/* Hero : eyebrow, titre sur deux lignes, sous-titre */}
      <div>
        <Bar className="h-2.5 w-24" />
        <Bar className="h-7 w-full mt-3" />
        <Bar className="h-7 w-2/3 mt-2" />
        <Bar className="h-3.5 w-4/5 mt-3" />
      </div>

      {/* Carrousel de campagnes — même hauteur (260px) que AdCarousel */}
      <div>
        <div className="shimmer rounded-3xl w-full" style={{ height: 260 }} />
        <div className="mt-3 flex items-center justify-center gap-1.5">
          <Bar className="h-1.5 w-6 rounded-full" />
          <Bar className="h-1.5 w-1.5 rounded-full" />
          <Bar className="h-1.5 w-1.5 rounded-full" />
        </div>
      </div>

      {/* Barre « Bonus chance » (AdGate) */}
      <div className="rounded-2xl border border-border bg-card px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          <Bar className="h-3 w-40" />
          <Bar className="h-3 w-8" />
        </div>
        <Bar className="h-1.5 w-full mt-2 rounded-full" />
      </div>

      {/* Slider des lots — cartes partiellement visibles, comme au scroll */}
      <div>
        <div className="flex items-baseline justify-between mb-2.5">
          <Bar className="h-3.5 w-28" />
          <Bar className="h-2.5 w-16" />
        </div>
        <div className="flex gap-2.5 overflow-hidden">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="shrink-0 w-[70%] max-w-[260px] overflow-hidden rounded-xl border border-border bg-card"
            >
              <div className="shimmer h-28 w-full" />
              <div className="p-3 pt-3.5">
                <Bar className="h-3.5 w-4/5" />
                <Bar className="h-3.5 w-1/2 mt-2" />
                <Bar className="h-2.5 w-2/3 mt-3" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Formulaire de participation */}
      <div className="rounded-2xl border border-border bg-card p-4 space-y-3">
        <Bar className="h-4 w-1/2" />
        <Bar className="h-11 w-full rounded-xl" />
        <Bar className="h-11 w-full rounded-xl" />
        <Bar className="h-12 w-full rounded-full" />
      </div>
    </div>
  );
}
